import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../common/AbstractListView";


import constants from '../../constants';
import Select from "../../ui/Select";
import {FilterStorageVersion, Search} from "../../filtering";
import {
  DateRenderer,DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../uiControls/SmartTableRenderers';
import ApplicationContext, { IApplicationContext } from '../../ApplicationContext';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../common/JobListViewContext';

import {JobNames} from "../../framework.core/JobNames";
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';

import {MOTFilterRenderer} from '../common/commonListRenderers';
import * as XCol from '../../framework.core/XExportColumn';

import { getFmsGlobal } from '../../globals';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import _ from 'lodash';
import { Decimalformat, nullableCheckBoxValue } from '../common/commonExportFormat';
import { useAppSelector } from '../../app/hooks';
import { OrchidBaroListItem } from '../../fms.data/models/OrchidBaroListItem';
import CompanyDropDown from '../../uiControls/CompanyDropDown';
import PrimaryInverseButton from '../../ui/PrimaryInverseButton';
import { useHistory } from 'react-router-dom';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import { orchidBaroList } from '../brokerageTrucking/tableSettings';
import { addDays, compareIso, now } from '../../dateUtils';
import LeftRightSplit from '../../ui/LeftRightSplit';

const trackEvent1 = ['empty out', 'full in', 'vessel loaded'];
const trackEvent2 = ['vessel departed', 'transshipment arrived', 'transshipment discharged', 'transshipment loaded','transshipment departed', 'eta change'];
const trackEvent3 = ['vessel arrived','vessel berthed','vessel discharged','holds at pod terminal','pod terminal changed','pod terminal','pickup lfd','pickup appointment at' ,'available for pickup'];
const trackEvent4 = ['full out','empty in'];

export enum shipmentStatus{
  NotDeparted,
  InTransit,
  PortTerminal,
  LaxOrigin,
  InInlandTransit,
}


//orchidBaro ShipmentStatus
export  const orchidBaroShipmentStatus = [
  {color: 'D3D3D3', label : 'NOT DEPARTED'},
  {color: 'FF8FB8', label : 'IN TRANSIT'},
  {color: '4AA1FF', label : 'PORT TERMINAL'},
  {color: '6CA62C', label : 'LAX ORIGIN'},
  {color: 'FFFF00', label : 'IN INLAND TRANSIT'},
]

//orchidBaro Weight
export const orchidBaroWeight = [
  {color: '008000', label: '<=  44,000 LBS'}, //green
  {color: 'ffb62e', label: '<=  48,000 LBS'}, //orange
  {color: 'FF0000', label: '>  48,000 LBS'},  //red
]


function ChbRenderer({ cell, row, data }:any) {
  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;
  return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;
}

function ContainerRenderer({cell, row, data}: any){
  const l = data[row.index];
  const trType = l.trType;
  const containerNo = l.containerNo;
  const appContext = useContext(ApplicationContext);
  const fmsGlobal = getFmsGlobal();
  let link = `https://quicktrack2.suntekscm.com/?licid=${fmsGlobal.AcmeID}&mbl=${cell.row.original.mblNo}&hbl=${cell.row.original.hblNo}&cntr=${cell.row.original.containerNo}&email=${appContext.user?.email}`;
  if(trType === 'M'){
    data[row.index].cntrLink = link;
    return <div id={`${cell.column.id}-${row.index}`}><a target="_blank" rel="noreferrer" href={link} style={{color:'#0052BD'}}>{containerNo}</a></div>
  } else{
    data[row.index].cntrLink = '';
    return <div id={`${cell.column.id}-${row.index}`}>{containerNo}</div>
  }
}

function LbsRenderer({cell, row, data}: any){
  const l = data[row.index];
  const lbs = l.lbs;
  let color = 'black';
  let tooltipValue = "";
  if(lbs <= 44000){
    color = `#${orchidBaroWeight[0].color}`;
    tooltipValue = '<= 44,000 LBS';
  } else if (lbs > 44000 && lbs <=48000){
    color=`#${orchidBaroWeight[1].color}`; //yellow가 표에서 잘 안 보여서 orange로 임시 표시
    tooltipValue = '<= 48,000 LBS'
  } else {
    color = `#${orchidBaroWeight[2].color}`;
    tooltipValue = '> 48,000 LBS';
  }

  return <FloatRenderer tooltipValue={tooltipValue} row={row} cell={cell} color={color} decimals={0} />;

}

function CbpHoldRenderer({cell, row, data}: any){
  const l = data[row.index];
  const cbpHold = l.cbpHold;
  let displayText='';
  let color = 'black';
  if(cbpHold){
    if(['1H', '1G','2H','3H','5H','7H'].includes(cbpHold)){
      displayText = 'CBP Hold';
      color='red';
    } else if(['1I', '1F','2I','3I','5I','7I'].includes(cbpHold)){
      displayText = 'Hold Removed';
      color='black';
    } 
  } else {
    if(l.chbRspCode){
      if(['1H', '1G','2H','3H','5H','7H'].includes(l.chbRspCode)){
        displayText = 'CBP Hold';
        color='red';
      } else if(['1I', '1F','2I','3I','5I','7I'].includes(l.chbRspCode)){
        displayText = 'Hold Removed';
        color='black';
      } 
    }
  }

  return <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{color}}>{displayText}</div>
}

function TrackingNoRenderer({cell, row, data}: any){
  const l = data[row.index];
  const trackingNo = l.trackingNo;
  const sharedURL = l.sharedURL;
  if (trackingNo && sharedURL){
    return <div className='ifms-table-align-center' id={`${cell.column.id}-${row.index}`}><a target="_blank" style={{color:'#0052BD'}} rel="noreferrer" href={`https://platform.tive.com/shared/shipment/${sharedURL}`}>{trackingNo}</a></div>
  }else {
    return <div className='ifms-table-align-center' id={`${cell.column.id}-${row.index}`}>{trackingNo}</div>
  }

}

function ExportStatusBackColor(accessor: string, value: any){
  const data = value[accessor];
  const mot = value['mot'];
  const eta = value['eta'];
  const etd = value['metd'];
  const loadId = value['loadId'];
  const loadStatus = value['loadStatus'];
  let status = undefined;
  let color = 'none';
  if(data){
    if (trackEvent1.includes(data)){
      status = shipmentStatus.NotDeparted; //Not departed
    } else if (trackEvent2.includes(data)){
      status = shipmentStatus.InTransit; //In Transit
    } else if (trackEvent3.includes(data)){
      status = shipmentStatus.PortTerminal; // port terminal
    } else if (trackEvent4.includes(data) && loadStatus === 'In-Transit'){
      status = shipmentStatus.InInlandTransit;  // in inland transit
    } else if (trackEvent4.includes(data) && loadStatus === 'Not Departed'){
      status = shipmentStatus.LaxOrigin;  // lax origin
    } else if (trackEvent4.includes(data) && !loadId){ //last event는 있는데 load랑 연결되지 않은 경우
      status = shipmentStatus.LaxOrigin; 
    } 

  } else if(!data){
    if(mot === 'Air' || mot === 'Truck'){
      if(eta && (compareIso(now(), eta) >= 0)) status = shipmentStatus.LaxOrigin; //ETA가 지났을때
      else if(eta && (compareIso(now(), eta) < 0)) status = shipmentStatus.NotDeparted; //ETA가 안 지났을때
      else if(!etd && !eta) status = shipmentStatus.NotDeparted; //ETD도 없고 ETA도 없을때 
      else if( etd && !eta && (compareIso(now(), addDays(etd, 1)) >= 0)) status = shipmentStatus.LaxOrigin; 
      else if( etd && !eta && (compareIso(addDays(etd, 1), now()) > 0)) status = shipmentStatus.InInlandTransit;
    
    } else if (mot === 'Ocean'){ //수정필요
      if(loadId){
        if(eta && (compareIso(now(), eta) >= 0) && loadStatus === 'Not Departed'){
          status = shipmentStatus.LaxOrigin;  // lax origin
        }
        else if(eta && (compareIso(now(), eta) >= 0) && loadStatus === 'In-Transit'){
          status = shipmentStatus.InInlandTransit;
        } else {
          status = shipmentStatus.NotDeparted; //Load랑 연결되어있는데 LastEvent 없는 경우
        }
      } else{
        status = shipmentStatus.NotDeparted;
      }
    } 
  }

  if (status !== undefined) color = orchidBaroShipmentStatus[status].color;
  
  return color;
}


export function StatusBackColor(data: OrchidBaroListItem){
  const l = data;
  let color = '';
  let status = undefined;
  let text = '';
  if(l.lastEvent){
    if (trackEvent1.includes(l.lastEvent)){
      status = shipmentStatus.NotDeparted;
    } else if (trackEvent2.includes(l.lastEvent)){
      status = shipmentStatus.InTransit;
    } else if (trackEvent3.includes(l.lastEvent)){
      status = shipmentStatus.PortTerminal;
    } else if (trackEvent4.includes(l.lastEvent) && l.loadStatus === 'In-Transit'){
      status = shipmentStatus.InInlandTransit;
    } else if (trackEvent4.includes(l.lastEvent) && l.loadStatus === 'Not Departed'){
      status = shipmentStatus.LaxOrigin;
    } else if (trackEvent4.includes(l.lastEvent) && !l.loadId){
      status = shipmentStatus.LaxOrigin;
    } 

  } else if(!l.lastEvent){
    if(l.mot === 'Air' || l.mot === 'Truck'){
      if(l.eta && (compareIso(now(), l.eta) >= 0)) status = shipmentStatus.LaxOrigin; //ETA가 지났을때
      else if(l.eta && (compareIso(now(), l.eta) < 0)) status = shipmentStatus.NotDeparted; //ETA가 안 지났을때
      else if(!l.metd && !l.eta)       status = shipmentStatus.NotDeparted; //ETD도 없고 ETA도 없을때 
      else if( l.metd && !l.eta && (compareIso(now(), addDays(l.metd,1)) >= 0)) status = shipmentStatus.LaxOrigin; 
      else if( l.metd && !l.eta && (compareIso(addDays(l.metd, 1), now()) > 0)) status = shipmentStatus.InInlandTransit;
    } else if (l.mot === 'Ocean'){
      if(l.loadId){
        if(l.eta && (compareIso(now(), l.eta) >= 0) && l.loadStatus === 'Not Departed'){
          status = shipmentStatus.LaxOrigin;  // lax origin
        }
        else if(l.eta && (compareIso(now(), l.eta) >= 0) && l.loadStatus === 'In-Transit'){
          status = shipmentStatus.InInlandTransit;
        } else {
          status = shipmentStatus.NotDeparted; //Load랑 연결되어있는데 LastEvent 없는 경우
        }
      } else {
        status = shipmentStatus.NotDeparted;
      }
    } 
  }

  if (status !== undefined ) color = `#${orchidBaroShipmentStatus[status].color}`;
  
  return color;
}

function ExportContainerTracking(accessor: string, value: any, appContext: IApplicationContext){
  const email = appContext.user?.email??'';
  const data = value[accessor];
  if(!!data){
    if(value['trType'] === 'M'){
      return `https://quicktrack2.suntekscm.com/?licid=${getFmsGlobal().AcmeID}&mbl=${value['mblNo']}&hbl=${value['hblNo']}&cntr=${data}&email=${email}`;
    } else{
      return '';
    }
  }
}

function ExportTrackingNo(value: any){
  if(!!value){
   return `https://platform.tive.com/shared/shipment/${value}`;
  } else {
    return '';
  }
}

function ExportCbpHoldValue(value: any){
  if(!!value){
    if(['1H', '1G','2H','7H'].includes(value)){
      return 'CBP Hold';
    } else if(['1I', '1F','2I','7I'].includes(value)){
      return 'Hold Removed';
    } 
    return '';
  }
  return '';
}

  function ExportWeightColor(accessor: string, value: any){
  const data = value[accessor];
  let color = '000000';
  if(!!data){
    if(data <= 44000){
      color = orchidBaroWeight[0].color;
    } else if (data > 44000 && data <=48000){
      color=orchidBaroWeight[1].color; //yellow가 표에서 잘 안 보여서 orange로 임시 표시
    } else {
      color = orchidBaroWeight[2].color;
    }
  }
  return color;
}

function ExportCbpHoldColor(accessor: string, value: any){
  const data = value[accessor];
  let color = '000000';
  if(!!data){
    if(['1H', '1G','2H','7H'].includes(data)){
      color = 'FF0000';
    } 
  }
  return color;
}

function OrderNoRenderer({cell,row,data}: any){
  const {switchToOrderDetail} = useOrchidBaroOperations();
  const l = data[row.index];
 if(!cell.value || l.orderCnt > 1){
     return <div className="ifms-table-default">{cell.value}</div>;
   }
 
   return <PrimaryInverseButton onClick={() => switchToOrderDetail(data[row.index])} style={{width: '100%', lineHeight:'1em', color:'#0052BD'}}>{cell.value}</PrimaryInverseButton>
}


function useOrchidBaroOperations(){
  const history = useHistory();
  function switchToOrderDetail(baro: OrchidBaroListItem|null){
    if(!baro){
      return;
    }
    openNewPage(history, `/brokerageTrucking/order/view/${baro.id}?Baro=true`, NavigationType.newPage );
  }

  return {switchToOrderDetail}
}

// function ShipmentStatus(){
//   const appContext = useContext(ApplicationContext);
//   const darkMode = appContext.useDarkMode;
//   return (
//     <div style={{marginLeft:'200px', padding:'15',marginTop: '16px', color: darkMode ? 'white': 'black'}}>
//     <ul style={{ listStyle: "none", padding: 0, display: "flex", gap: 12 }}>
//       {orchidBaroShipmentStatus.map((entry, index) => (
//         <li key={`item-${index}`} style={{ display: "flex", alignItems: "center" }}>
//           <div
//             style={{
//               width: 10,
//               height: 10,
//               backgroundColor: `#${entry.color}`,
//               marginRight: 6,
//             }}
//           />
//           <span>{entry.label}</span>
//         </li>
//       ))}
//     </ul>
//   </div>
//   );
// }



function AfterMemoLogButtonCommands() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const storage = useAppSelector(x => x.storage);
  const [listFilter, setListFilter, ] = useTypedFastStorage<number>('OrchidBaro-ListFilter', 0);
  const [listStatusFilter, setListStatusFilter] = useTypedFastStorage<number>('OrchidBaro-status-ListFilter', 0);
  useEffect(() => {
    changeOrchidBaroListItem(listFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listFilter]);

  useEffect(() => {
    changeOrchidBaroListStatusItem(listStatusFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ listStatusFilter]);

  function changeOrchidBaroListItem(listFilter: number){
    jobListContext.setListFilterType(listFilter);
  }

  function changeOrchidBaroListStatusItem(listStatusFilter: number){
    jobListContext.setListFilterType2(listStatusFilter);
  }
  
  

  return (
    <>
      <div style={{marginLeft:'10px', marginTop:'10px', width:'300px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'120px'}
          rightSize={'180px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'20px'}}>Customer /  U.Cnee</label> }
          right={
            <div style={{lineHeight:'14px', maxHeight:'300px',}}>

            <CompanyDropDown
            name="ifms-orchidBaro-list-filter"
            value={listFilter ?? 0}
            onChange={e => {setListFilter(e?.id || 0)}}
            />
            </div>
          }
        />
      </div>
      <div style={{marginLeft:'20px', marginTop:'10px', width:'300px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'100px'}
          rightSize={'180px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'20px'}}>Shipment Status</label> }
          right={
            <div style={{lineHeight:'14px', maxHeight:'300px',}}>

            <Select

            name="ifms-orchidBaro-list-status-filter"
            value={listStatusFilter ?? 0}
            items={[
              {value: 0, label: 'ALL'},
              {value: 1, label:'NOT DEPARTED'},
              {value: 2, label:'IN TRANSIT'},
              {value: 3, label:'PORT TERMINAL'},
              {value: 4, label:'LAX ORIGIN'},
              {value: 5, label:'IN INLAND TRANSIT'},
            ]}
            onChange={e => {setListStatusFilter(Number(e.target.value))}}
            />
            </div>
          }
        />
      </div>

    </>
  )
}

function AfterCloseBtnCommands(){
  return <></>;    
}


function ListCommands() {
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);


  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
      </div>

    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {


}

function formatData(data:Array<OrchidBaroListItem>) {
  return data.map(d => ({
    ...d,
  }));
}



/**
 * Concrete implementation for OrchidBaro List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OrchidBaro,
      'OrchidBaroListItem',
      OrchidBaroListItem.calculateSearchParameters(search, OrchidBaroListItem.MapSearchFields),
      1,
      0);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'mot',
        renderer: MOTFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'fmot',
        renderer: MOTFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return OrchidBaroListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      else if (x.dataIndex === 'containerNo') colRenderer.Cell = ContainerRenderer;
      else if (x.dataIndex === 'cbpHold') colRenderer.Cell = CbpHoldRenderer;
      else if (x.dataIndex === 'trackingNo') colRenderer.Cell = TrackingNoRenderer;
      else if (x.dataIndex === 'orderNo') colRenderer.Cell = OrderNoRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if ( x.dataIndex === 'lbs'){
          colRenderer.Cell = LbsRenderer;
        }
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  



  getExportRenderers(appContext : IApplicationContext): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'lastEvent',  backgroundColor: (value: any)=>{return ExportStatusBackColor('lastEvent',value)} });
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return Decimalformat(value['pkgs'],0) } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],0) },  fontColor: (value: any) => {return ExportWeightColor('lbs', value)} });
    colRenderer.push({ accessor:'containerNo', hyperLink: (value: any) => {return ExportContainerTracking('containerNo', value, appContext)}} );
    colRenderer.push({ accessor: 'pl', changedValue: (value: any) => { return nullableCheckBoxValue(value['pl']) } });
    colRenderer.push({ accessor: 'ci', changedValue: (value: any) => { return nullableCheckBoxValue(value['ci']) } });
    colRenderer.push({ accessor: 'trackingNo', hyperLink: (value: any) => {return ExportTrackingNo(value['sharedURL'])} });
    colRenderer.push({ accessor: 'cbpHold', changedValue:(value: any) => {return ExportCbpHoldValue(value['cbpHold'])}, fontColor: (value: any) => {return ExportCbpHoldColor('cbpHold', value)} });
    return colRenderer;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

  }

getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  orchidBaroList;
    const cols = OrchidBaroListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <></>//<ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OrchidBaroListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Orchid Baaro List';
  };

  renderAdditionalCommands() {
    return <></>;
  }

  hasRightClickContext(): boolean {
    return false;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <></>;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(): React.ReactNode {
    return <></>;
  }
  
  useLogHistory(): boolean {
    return true;
  }
  hasMemo(): boolean {
   return false; 
  }
  commandsAfterCloseBtn(): React.ReactNode {
    return <AfterCloseBtnCommands />
  }
}

export default ListView;

